<template>
  <div>
    <div class="pulsing-grey-bar"/>
    <div class="col-md-3 pulsing-grey-card"/>
    <div class="col-md-3 pulsing-grey-card"/>
    <div class="col-md-3 pulsing-grey-card"/>
  </div>
</template>


<script>

export default {
  name: 'PresentLevelsLoadingGoalCards'
}
</script>

<style lang="less" scoped>
.pulsing-grey-card {
  background-color: #E6E6E6;
  height: 220px;
  animation: animate 2s linear infinite;
  border-radius: 1px;
  margin-right: 8px;
}
.pulsing-grey-bar {
  background-color: #E6E6E6;
  width: 400px;
  height: 8px;
  animation: animate 2s linear infinite;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 5px;
}
@keyframes animate {
    0% {
        opacity: 0.3;
    }

    50% {
        opacity: 0.7;
    }

    100% {
        opacity: 0.3;
    }
}
.row {
  margin-left: 0;
}
</style>
